<template>
  <express-fee-promotion-details :is-edit='false'>
  </express-fee-promotion-details>
</template>

<script>
import ExpressFeePromotionDetails from '../ExpressFeePromotionDetails'
export default {
  name: 'CreateExpressFeePromotion',
  components: {
    ExpressFeePromotionDetails
  }
}
</script>

